/*
these substitutions are intentionally isolated from those in
src/regexes.js and src/templates.js
because the very process of incrementally building up valid XML/HTML
can involve injecting identical characters that must NOT be encoded.

https://en.wikipedia.org/wiki/List_of_XML_and_HTML_character_entity_references
*/
function substituteEncodedCarets (text) {
  if (!text) return ''
  text = text.replace(/</g, '&lt;')
  text = text.replace(/>/g, '&gt;')
  return text
}

module.exports = substituteEncodedCarets
